export type Lang = 'en' | 'es'

export const BUSINESS = {
  name: 'JV Home Service',
  owner: 'Julio Vasquez',
  phoneDisplay: '(832) 996-1200',
  phoneHref: 'tel:+18329961200',
  whatsappHref: 'https://wa.me/18329961200',
  email: 'Jvhomeservice759@gmail.com',
  area: 'Northwest Houston, TX',
}

type Dict = Record<string, string>

const en: Dict = {
  'nav.services': 'Services',
  'nav.gallery': 'Gallery',
  'nav.about': 'About Us',
  'nav.contact': 'Contact',
  'nav.cta': 'Get Free Quote',
  'nav.menu': 'Open menu',
  'nav.close': 'Close menu',
  'nav.language': 'Change language',

  'hero.eyebrow': 'Serving Northwest Houston & surrounding areas',
  'hero.title': 'Professional Home Remodeling & Repairs in Northwest Houston',
  'hero.sub':
    'Quality workmanship. Licensed & insured. Residential & commercial. Se habla español.',
  'hero.areas':
    'Serving Northwest Houston, Cypress, Spring, Tomball, Katy and The Woodlands.',
  'hero.call': 'Call Now: (832) 996-1200',
  'hero.quote': 'Request Free Quote',
  'hero.stat1': 'Years of experience',
  'hero.stat2': 'Projects completed',
  'hero.stat3': 'Free estimates',

  'trust.licensed': 'Licensed & Insured',
  'trust.licensed.sub': 'Fully covered on every job',
  'trust.years': '10+ Years Experience',
  'trust.years.sub': 'Residential & commercial',
  'trust.free': 'Free Estimates',
  'trust.free.sub': 'On-site, no obligation',
  'trust.spanish': 'Se Habla Español',
  'trust.spanish.sub': 'Bilingual team, clear answers',

  'services.eyebrow': 'What we do',
  'services.title': 'Home Remodeling & Repair Services in Northwest Houston, TX',
  'services.sub':
    'One crew, one point of contact, from tear-out to final walkthrough — repairs and remodels done right the first time.',
  'services.cta': 'Request quote',
  'services.remodeling.title': 'Remodeling',
  'services.remodeling.desc':
    'Kitchen and bathroom remodeling in Northwest Houston, Cypress, and Spring. Additions and full interior renovations with premium finishes.',
  'services.roofing.title': 'Roofing',
  'services.roofing.desc':
    'Roofing repairs and re-roofs in Houston, TX. Storm damage restoration with shingle systems built for Texas weather. Serving Cypress, Tomball, and surrounding areas.',
  'services.siding.title': 'Siding',
  'services.siding.desc':
    'Fiber cement, vinyl and wood siding replacement in Northwest Houston. Professional siding installation in Cypress, Spring, and The Woodlands. Seals and protects your exterior.',
  'services.foundation.title': 'Foundation Repair',
  'services.foundation.desc':
    'Foundation repair in Houston, TX including pier and beam leveling, slab jacking, crack repair and drainage correction. Serving Northwest Houston, Cypress, and surrounding areas.',
  'services.demolition.title': 'Demolition',
  'services.demolition.desc':
    'Selective interior demolition and full structure demolition services in Northwest Houston, TX. Clean debris removal. Serving Cypress, Tomball, Spring and The Woodlands.',

  'why.eyebrow': 'Why homeowners choose JV',
  'why.title': 'Why Northwest Houston Homeowners Choose JV Home Service',
  'why.craft.title': 'Expert Craftsmanship',
  'why.craft.desc':
    'Tight details and premium finishes. We treat the last 5% of a job like the first.',
  'why.fast.title': 'Fast & Reliable',
  'why.fast.desc':
    'We show up when we say we will and hold the schedule we committed to.',
  'why.price.title': 'Competitive Pricing',
  'why.price.desc':
    'Fair, itemized estimates so you know exactly what you are paying for.',
  'why.pm.title': 'Full Project Management',
  'why.pm.desc':
    'Permits, materials and crews handled start to finish. No surprises.',

  'how.eyebrow': 'How it works',
  'how.title': 'Three steps from first call to finished project',
  'how.s1.title': 'Contact us by phone or WhatsApp',
  'how.s1.desc':
    'Tell us what you need. We answer in English or Spanish and usually respond the same day.',
  'how.s2.title': 'Free on-site estimate & consultation',
  'how.s2.desc':
    'Julio walks the project with you, measures, and gives you a written price with no pressure.',
  'how.s3.title': 'We complete your project with excellence',
  'how.s3.desc':
    'Clean work areas, daily updates and a final walkthrough before we call it done.',

  'show.eyebrow': 'Home remodeling & repair projects in Northwest Houston',
  'show.title': 'Before, during and after',
  'show.sub':
    'Every project below is our own work in Northwest Houston, Cypress, Spring and Tomball — nothing staged.',
  'show.before': 'Before',
  'show.process': 'Process',
  'show.after': 'After',
  'show.prev': 'Previous project',
  'show.next': 'Next project',
  'show.counter': 'Project',
  'show.cta': 'Get a quote for a project like this',

  'proj.roof.title': 'Full Re-Roof After Storm Damage',
  'proj.roof.cat': 'Roofing Project',
  'proj.roof.loc': 'Cypress, TX',
  'proj.roof.desc':
    'Complete tear-off, new synthetic underlayment and architectural shingles, finished in four days.',
  'proj.foundation.title': 'Slab Leveling & Crack Repair',
  'proj.foundation.cat': 'Foundation Repair',
  'proj.foundation.loc': 'Jersey Village, TX',
  'proj.foundation.desc':
    'Twelve concrete piers installed, slab lifted back to level, brickwork repointed and drainage corrected.',
  'proj.siding.title': 'Fiber Cement Siding Replacement',
  'proj.siding.cat': 'Siding Remodel',
  'proj.siding.loc': 'Spring, TX',
  'proj.siding.desc':
    'Rotted wood siding removed down to the studs, new weather barrier and fiber cement lap siding installed.',
  'proj.gallery.title': 'Gallery Room Renovation',
  'proj.gallery.cat': 'Remodeling Project',
  'proj.gallery.loc': 'Tomball, TX',
  'proj.gallery.desc':
    'Enclosed patio converted to finished gallery room with new framing, ceiling installation, drywall finishing, and complete interior renovation.',
  'proj.bath.title': 'Master Bathroom Renovation',
  'proj.bath.cat': 'Remodeling Project',
  'proj.bath.loc': 'Northwest Houston, TX',
  'proj.bath.desc':
    'Tub removed for a waterproofed walk-in shower, floating vanity and new tile floor.',

  'test.eyebrow': 'Client reviews',
  'test.title': 'What Houston homeowners say',
  'test.t1.quote':
    'They leveled our slab in three days and cleaned up like they were never here. Honest pricing, no surprises.',
  'test.t1.name': 'Carlos M., Houston TX',
  'test.t1.service': 'Foundation Repair',
  'test.t2.quote':
    'Julio walked me through every option and the new roof looks better than the original. Great communication.',
  'test.t2.name': 'Amanda R., Cypress TX',
  'test.t2.service': 'Roofing',
  'test.t3.quote':
    'Our kitchen went from dated to gorgeous. The crew respected our home and hit the timeline exactly.',
  'test.t3.name': 'Diana & Luis P., Spring TX',
  'test.t3.service': 'Kitchen Remodeling',
  'test.t4.quote':
    'New siding completely changed the house. Fair estimate, fast work, and they answered every call.',
  'test.t4.name': 'Marcus T., Tomball TX',
  'test.t4.service': 'Siding',

  'faq.eyebrow': 'Questions',
  'faq.title': 'Frequently asked questions',
  'faq.q1': 'How do I get a free estimate for home remodeling in Houston?',
  'faq.a1':
    'Call or text (832) 996-1200, message us on WhatsApp, or send the form on this page. We schedule a free on-site visit, usually within 48 hours, and give you a written estimate.',
  'faq.q2': 'Is JV Home Service licensed and insured in Texas?',
  'faq.a2':
    'Yes. JV Home Service carries general liability coverage and works with licensed trades for electrical, plumbing and structural work. We can provide proof of insurance before we start.',
  'faq.q3': 'How long do remodeling and roofing projects take?',
  'faq.a3':
    'Roof replacements typically take 1–4 days, foundation repairs 2–5 days, siding 3–7 days, and full kitchen or bath remodels 2–5 weeks. You get a schedule in writing with your estimate.',
  'faq.q4': 'Do you warranty your work?',
  'faq.a4':
    'Yes. Labor is warrantied for one year on repairs and longer on major installs, plus the manufacturer warranty on materials like shingles and siding.',
  'faq.q5': 'Do you speak Spanish?',
  'faq.a5':
    'Sí. Julio and the crew are fully bilingual, so estimates, contracts and daily updates can be handled in Spanish or English.',
  'faq.q6': 'Do you serve commercial properties in Houston?',
  'faq.a6':
    'Yes. We handle commercial roofing, remodels, build-outs and demolition for offices, retail spaces and rental properties across Northwest Houston.',

  'contact.eyebrow': 'Free estimate',
  'contact.title': 'Tell us about your project',
  'contact.sub':
    'Send the details and Julio will get back to you personally, usually the same day.',
  'contact.name': 'Full Name',
  'contact.phone': 'Phone',
  'contact.service': 'Service Needed',
  'contact.address': 'Address',
  'contact.message': 'Message',
  'contact.namePh': 'Julio Vasquez',
  'contact.phonePh': '(832) 000-0000',
  'contact.addressPh': 'Street, city, ZIP',
  'contact.messagePh': 'Tell us what needs to be done, and when you would like to start.',
  'contact.select': 'Select a service',
  'contact.other': 'Other',
  'contact.submit': 'Request Free Estimate',
  'contact.whatsapp': 'Message via WhatsApp',
  'contact.err.name': 'Please enter your full name.',
  'contact.err.phone': 'Enter a valid phone number with at least 10 digits.',
  'contact.err.service': 'Please choose the service you need.',
  'contact.err.address': 'Please enter the project address.',
  'contact.success.title': 'Request received',
  'contact.success.body':
    'Thanks — we have your details. Julio will call you at the number you provided, usually within one business day.',
  'contact.success.again': 'Send another request',
  'contact.sending': 'Sending…',
  'contact.optional': 'optional',
  'contact.infoTitle': 'Direct contact',
  'contact.hoursLabel': 'Hours',
  'contact.hours1': 'Mon–Fri: 7:00am – 6:00pm',
  'contact.hours2': 'Sat: 8:00am – 4:00pm',
  'contact.hours3': 'Sun: Closed',
  'contact.areaLabel': 'Service area',

  'footer.tagline':
    'Expert home remodeling & repair services in Northwest Houston.',
  'footer.company': 'Company',
  'footer.quick': 'Quick Links',
  'footer.services': 'Services',
  'footer.contact': 'Contact',
  'footer.testimonials': 'Testimonials',
  'footer.faq': 'Frequently Asked Questions',
  'footer.areas': 'Service Areas',
  'footer.areasText':
    'Serving Northwest Houston, Cypress, Spring, Tomball, Katy and The Woodlands.',
  'footer.phoneLabel': 'Phone',
  'footer.emailLabel': 'Email',
  'footer.addressLabel': 'Address',
  'footer.hoursLabel': 'Hours',
  'footer.hoursLine': 'Mon–Fri: 7:00am – 6:00pm | Sat: 8:00am – 4:00pm | Sun: Closed',
  'footer.rights': '© 2026 JV Home Service. All rights reserved.',
  'footer.licensed': 'Licensed & Insured · Se habla español',
  'footer.social': 'Follow JV Home Service',

  'about.eyebrow': 'About us',
  'about.title': 'A Houston contractor you can reach directly',
  'about.body':
    'JV Home Service is led by Julio Vasquez, who has spent over a decade building, repairing and remodeling homes across Northwest Houston. Julio runs every project himself — you talk to the person doing the work, not a call center. Residential and commercial, English and Spanish.',
  'about.areasTitle': 'Serving the Greater Northwest Houston Area',
  'about.areasBody':
    'We serve homeowners and businesses throughout Northwest Houston including Cypress, Spring, Tomball, Katy, and The Woodlands. Every project receives the same level of attention and quality, whether it is a small repair or a complete home renovation.',
  'about.point1': 'Owner on-site for every project',
  'about.point2': 'Written, itemized estimates',
  'about.point3': 'Clean job sites, daily updates',

  'wa.float': 'Chat on WhatsApp',
  'wa.tooltip': 'Chat with us on WhatsApp',
}

const es: Dict = {
  'nav.services': 'Servicios',
  'nav.gallery': 'Galería',
  'nav.about': 'Nosotros',
  'nav.contact': 'Contacto',
  'nav.cta': 'Presupuesto Gratis',
  'nav.menu': 'Abrir menú',
  'nav.close': 'Cerrar menú',
  'nav.language': 'Cambiar idioma',

  'hero.eyebrow': 'Servimos el noroeste de Houston y áreas cercanas',
  'hero.title': 'Remodelación y Reparación Profesional de Casas en el Noroeste de Houston',
  'hero.sub':
    'Trabajo de calidad. Con licencia y asegurados. Residencial y comercial. Se habla español.',
  'hero.areas':
    'Servimos el noroeste de Houston, Cypress, Spring, Tomball, Katy y The Woodlands.',
  'hero.call': 'Llame Ahora: (832) 996-1200',
  'hero.quote': 'Pedir Presupuesto Gratis',
  'hero.stat1': 'Años de experiencia',
  'hero.stat2': 'Proyectos completados',
  'hero.stat3': 'Presupuestos gratis',

  'trust.licensed': 'Con Licencia y Asegurados',
  'trust.licensed.sub': 'Cobertura en cada trabajo',
  'trust.years': '10+ Años de Experiencia',
  'trust.years.sub': 'Residencial y comercial',
  'trust.free': 'Presupuestos Gratis',
  'trust.free.sub': 'En sitio, sin compromiso',
  'trust.spanish': 'Se Habla Español',
  'trust.spanish.sub': 'Equipo bilingüe, respuestas claras',

  'services.eyebrow': 'Lo que hacemos',
  'services.title': 'Servicios de Remodelación y Reparación en el Noroeste de Houston, TX',
  'services.sub':
    'Un solo equipo y un solo contacto, desde la demolición hasta la entrega final — bien hecho desde la primera vez.',
  'services.cta': 'Pedir presupuesto',
  'services.remodeling.title': 'Remodelación',
  'services.remodeling.desc':
    'Remodelación de cocinas y baños en el noroeste de Houston, Cypress y Spring. Ampliaciones y renovaciones interiores completas con acabados premium.',
  'services.roofing.title': 'Techos',
  'services.roofing.desc':
    'Reparación de techos y techos nuevos en Houston, TX. Restauración por daño de tormenta con sistemas hechos para el clima de Texas. Servimos Cypress, Tomball y áreas cercanas.',
  'services.siding.title': 'Siding',
  'services.siding.desc':
    'Reemplazo de siding de fibrocemento, vinilo y madera en el noroeste de Houston. Instalación profesional en Cypress, Spring y The Woodlands. Sella y protege su exterior.',
  'services.foundation.title': 'Reparación de Cimientos',
  'services.foundation.desc':
    'Reparación de cimientos en Houston, TX: nivelación pier and beam, levantamiento de losa, reparación de grietas y corrección de drenaje. Servimos el noroeste de Houston, Cypress y áreas cercanas.',
  'services.demolition.title': 'Demolición',
  'services.demolition.desc':
    'Demolición interior selectiva y demolición total en el noroeste de Houston, TX. Retiro y limpieza de escombros. Servimos Cypress, Tomball, Spring y The Woodlands.',

  'why.eyebrow': 'Por qué nos eligen',
  'why.title': 'Por Qué las Familias del Noroeste de Houston Eligen JV Home Service',
  'why.craft.title': 'Trabajo Experto',
  'why.craft.desc':
    'Detalles perfectos y acabados premium. Cuidamos el último 5% igual que el primero.',
  'why.fast.title': 'Rápidos y Confiables',
  'why.fast.desc':
    'Llegamos cuando lo prometemos y cumplimos el calendario acordado.',
  'why.price.title': 'Precios Competitivos',
  'why.price.desc':
    'Presupuestos justos y detallados para que sepa exactamente qué está pagando.',
  'why.pm.title': 'Manejo Total del Proyecto',
  'why.pm.desc':
    'Permisos, materiales y personal de inicio a fin. Sin sorpresas.',

  'how.eyebrow': 'Cómo funciona',
  'how.title': 'Tres pasos desde la primera llamada hasta el proyecto terminado',
  'how.s1.title': 'Contáctenos por teléfono o WhatsApp',
  'how.s1.desc':
    'Cuéntenos qué necesita. Atendemos en español o inglés y respondemos casi siempre el mismo día.',
  'how.s2.title': 'Estimado y consulta gratis en su casa',
  'how.s2.desc':
    'Julio revisa el proyecto con usted, toma medidas y le entrega un precio por escrito sin presión.',
  'how.s3.title': 'Completamos su proyecto con excelencia',
  'how.s3.desc':
    'Áreas limpias, avances diarios y una revisión final antes de dar el trabajo por terminado.',

  'show.eyebrow': 'Proyectos de remodelación y reparación en el noroeste de Houston',
  'show.title': 'Antes, durante y después',
  'show.sub':
    'Todos los proyectos aquí son trabajo nuestro en el noroeste de Houston, Cypress, Spring y Tomball — nada montado.',
  'show.before': 'Antes',
  'show.process': 'Proceso',
  'show.after': 'Después',
  'show.prev': 'Proyecto anterior',
  'show.next': 'Proyecto siguiente',
  'show.counter': 'Proyecto',
  'show.cta': 'Pedir presupuesto para un proyecto así',

  'proj.roof.title': 'Techo Nuevo Tras Daño por Tormenta',
  'proj.roof.cat': 'Proyecto de Techo',
  'proj.roof.loc': 'Cypress, TX',
  'proj.roof.desc':
    'Retiro completo, nueva membrana sintética y shingles arquitectónicos, terminado en cuatro días.',
  'proj.foundation.title': 'Nivelación de Losa y Reparación de Grietas',
  'proj.foundation.cat': 'Reparación de Cimientos',
  'proj.foundation.loc': 'Jersey Village, TX',
  'proj.foundation.desc':
    'Doce pilotes de concreto instalados, losa nivelada, ladrillo reparado y drenaje corregido.',
  'proj.siding.title': 'Reemplazo de Siding de Fibrocemento',
  'proj.siding.cat': 'Remodelación de Siding',
  'proj.siding.loc': 'Spring, TX',
  'proj.siding.desc':
    'Siding de madera podrido retirado hasta los postes, nueva barrera de agua y siding de fibrocemento.',
  'proj.gallery.title': 'Remodelación de Galeris',
  'proj.gallery.cat': 'Proyecto de Remodelación',
  'proj.gallery.loc': 'Tomball, TX',
  'proj.gallery.desc':
    'Patio convertido a sala de galería con nuevo encuadre, instalación de techo, acabado de drywall y renovación interior completa.',
  'proj.bath.title': 'Renovación de Baño Principal',
  'proj.bath.cat': 'Proyecto de Remodelación',
  'proj.bath.loc': 'Noroeste de Houston, TX',
  'proj.bath.desc':
    'Tina retirada para una ducha impermeabilizada, mueble flotante y piso de mosaico nuevo.',

  'test.eyebrow': 'Reseñas de clientes',
  'test.title': 'Lo que dicen las familias de Houston',
  'test.t1.quote':
    'Nivelaron nuestra losa en tres días y dejaron todo limpio. Precios honestos, sin sorpresas.',
  'test.t1.name': 'Carlos M., Houston TX',
  'test.t1.service': 'Reparación de Cimientos',
  'test.t2.quote':
    'Julio me explicó cada opción y el techo nuevo quedó mejor que el original. Excelente comunicación.',
  'test.t2.name': 'Amanda R., Cypress TX',
  'test.t2.service': 'Techos',
  'test.t3.quote':
    'Nuestra cocina pasó de anticuada a hermosa. El equipo respetó la casa y cumplió los tiempos.',
  'test.t3.name': 'Diana y Luis P., Spring TX',
  'test.t3.service': 'Remodelación de Cocina',
  'test.t4.quote':
    'El siding nuevo cambió la casa por completo. Presupuesto justo, trabajo rápido y siempre contestaron.',
  'test.t4.name': 'Marcus T., Tomball TX',
  'test.t4.service': 'Siding',

  'faq.eyebrow': 'Preguntas',
  'faq.title': 'Preguntas frecuentes',
  'faq.q1': '¿Cómo obtengo un presupuesto gratis de remodelación en Houston?',
  'faq.a1':
    'Llame o escriba al (832) 996-1200, mándenos un WhatsApp o llene el formulario de esta página. Agendamos una visita gratis, normalmente en 48 horas, y le damos un presupuesto por escrito.',
  'faq.q2': '¿Están asegurados y licenciados?',
  'faq.a2':
    'Sí. JV Home Service cuenta con seguro de responsabilidad civil y trabaja con oficios licenciados para electricidad, plomería y estructura. Podemos mostrar el comprobante antes de empezar.',
  'faq.q3': '¿Cuánto tiempo toman los proyectos?',
  'faq.a3':
    'Un techo nuevo toma de 1 a 4 días, cimientos de 2 a 5 días, siding de 3 a 7 días, y una remodelación completa de cocina o baño de 2 a 5 semanas. El calendario va por escrito con su presupuesto.',
  'faq.q4': '¿Ofrecen garantía en el trabajo?',
  'faq.a4':
    'Sí. La mano de obra tiene garantía de un año en reparaciones y más tiempo en instalaciones mayores, además de la garantía del fabricante en materiales como shingles y siding.',
  'faq.q5': '¿Hablan español?',
  'faq.a5':
    'Sí. Julio y el equipo son completamente bilingües, así que presupuestos, contratos y avances diarios pueden manejarse en español o inglés.',
  'faq.q6': '¿Sirven propiedades comerciales en Houston?',
  'faq.a6':
    'Sí. Hacemos techos, remodelaciones, adaptaciones y demolición comercial para oficinas, locales y propiedades de renta en todo el noroeste de Houston.',

  'contact.eyebrow': 'Presupuesto gratis',
  'contact.title': 'Cuéntenos sobre su proyecto',
  'contact.sub':
    'Envíe los detalles y Julio le responde personalmente, casi siempre el mismo día.',
  'contact.name': 'Nombre Completo',
  'contact.phone': 'Teléfono',
  'contact.service': 'Servicio Necesario',
  'contact.address': 'Dirección',
  'contact.message': 'Mensaje',
  'contact.namePh': 'Julio Vasquez',
  'contact.phonePh': '(832) 000-0000',
  'contact.addressPh': 'Calle, ciudad, código postal',
  'contact.messagePh': 'Cuéntenos qué necesita y cuándo le gustaría empezar.',
  'contact.select': 'Seleccione un servicio',
  'contact.other': 'Otro',
  'contact.submit': 'Pedir Presupuesto Gratis',
  'contact.whatsapp': 'Escribir por WhatsApp',
  'contact.err.name': 'Por favor escriba su nombre completo.',
  'contact.err.phone': 'Escriba un teléfono válido de al menos 10 dígitos.',
  'contact.err.service': 'Por favor elija el servicio que necesita.',
  'contact.err.address': 'Por favor escriba la dirección del proyecto.',
  'contact.success.title': 'Solicitud recibida',
  'contact.success.body':
    'Gracias — ya tenemos sus datos. Julio le llamará al número que dejó, normalmente en un día hábil.',
  'contact.success.again': 'Enviar otra solicitud',
  'contact.sending': 'Enviando…',
  'contact.optional': 'opcional',
  'contact.infoTitle': 'Contacto directo',
  'contact.hoursLabel': 'Horario',
  'contact.hours1': 'Lun–Vie: 7:00am – 6:00pm',
  'contact.hours2': 'Sáb: 8:00am – 4:00pm',
  'contact.hours3': 'Dom: Cerrado',
  'contact.areaLabel': 'Área de servicio',

  'footer.tagline':
    'Servicios expertos de remodelación y reparación en el noroeste de Houston.',
  'footer.company': 'Compañía',
  'footer.quick': 'Enlaces',
  'footer.services': 'Servicios',
  'footer.contact': 'Contacto',
  'footer.testimonials': 'Testimonios',
  'footer.faq': 'Preguntas Frecuentes',
  'footer.areas': 'Áreas de Servicio',
  'footer.areasText':
    'Servimos el noroeste de Houston, Cypress, Spring, Tomball, Katy y The Woodlands.',
  'footer.phoneLabel': 'Teléfono',
  'footer.emailLabel': 'Correo',
  'footer.addressLabel': 'Dirección',
  'footer.hoursLabel': 'Horario',
  'footer.hoursLine': 'Lun–Vie: 7:00am – 6:00pm | Sáb: 8:00am – 4:00pm | Dom: Cerrado',
  'footer.rights': '© 2026 JV Home Service. Todos los derechos reservados.',
  'footer.licensed': 'Con Licencia y Asegurados · Se habla español',
  'footer.social': 'Siga a JV Home Service',

  'about.eyebrow': 'Nosotros',
  'about.title': 'Un contratista de Houston al que puede llamar directo',
  'about.body':
    'JV Home Service está dirigido por Julio Vasquez, con más de una década construyendo, reparando y remodelando casas en el noroeste de Houston. Julio dirige cada proyecto en persona — usted habla con quien hace el trabajo, no con un call center. Residencial y comercial, en inglés y español.',
  'about.areasTitle': 'Servimos toda el Área Noroeste de Houston',
  'about.areasBody':
    'Atendemos casas y negocios en todo el noroeste de Houston, incluyendo Cypress, Spring, Tomball, Katy y The Woodlands. Cada proyecto recibe el mismo nivel de atención y calidad, sea una reparación pequeña o una renovación completa.',
  'about.point1': 'El dueño presente en cada proyecto',
  'about.point2': 'Presupuestos por escrito y detallados',
  'about.point3': 'Obras limpias y avances diarios',

  'wa.float': 'Chatear por WhatsApp',
  'wa.tooltip': 'Chatee con nosotros por WhatsApp',
}

export const translations: Record<Lang, Dict> = { en, es }
